import React from 'react';

function useIncrement(percentage) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= percentage) {
          return percentage;
        }
        return oldProgress + 1;
      });
    }, 25);
    return () => {
      clearInterval(timer);
    };
  }, [percentage]);
  return (
    progress
  );
}

export default useIncrement;
